import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt", "onerror"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: _normalizeClass(["navbar-brand", _ctx.brandClass]),
    to: _ctx.to
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        class: _normalizeClass(["align-top", _ctx.imgClass]),
        style: _normalizeStyle(_ctx.imgStyle),
        src: _ctx.computedSrc,
        alt: _ctx.alt,
        onerror: _ctx.onerror
      }, null, 14, _hoisted_1)
    ]),
    _: 1
  }, 8, ["class", "to"]))
}